<template>
    <div class="col conteudo">
        <div class="col">
            <img src="../../../assets/img/logo_np.png" class="logo mt-3" title="Grupo Negócios Públicos">
        </div>
        <h2 class="formularios pt-4">Quantidade de Participantes</h2>
        <p class="descritivo">Informe agora quantas pessoas você pretende levar ao evento (Presencial)</p>
        <div class="d-flex flex-column justify-content-center">

            <div v-if="idTipoEvento == 1 || idTipoEvento == 3">
                <div class="col-lg-8 col-sm-12 m-quantidade-participantes">
                    <label for="quantidade-participantes-presencial" id="q-participantes" class="col-lg-12 pb-1 d-flex justify-content-center">
                        Quantidade de Participantes Presencial
                    </label>
                    <input type="number" class="form-control text-center valid quantidade-participantes" id="quantidade-participantes-presencial" v-model="inscricao.qtdParticipantes">
                </div>
            </div>

            <div v-if="idTipoEvento == 2 || idTipoEvento == 3">
                <p class="descritivo pt-">Informe agora quantas pessoas você pretende levar ao evento (Online)</p>
                <div class="col-lg-8 col-sm-12 m-quantidade-participantes">
                    <label for="quantidade-participantes-online" id="q-participantes" class="col-lg-12 pb-1 d-flex justify-content-center">
                        Quantidade de Participantes Online
                    </label>
                    <input type="number" class="form-control text-center valid quantidade-participantes" id="quantidade-participantes-online" v-model="inscricao.qtdParticipantesOnline">
                </div>
            </div>

        </div>
        <h2 class="paragrafo-1 pt-3">Após confirmar seus dados, você poderá cadastrar os participantes de acordo com a quantidade informada.</h2>
        <h2 class="paragrafo-2">Também será enviado um email à você, com um link para cadastrar os participantes posteriormente.</h2>
    </div>
</template>

<script>
    export default {
        name: "Etapa_4",
        components: {

        },
        props: {
            inscricao_value: {
                type: Object,
                required: true
            },
            instituicao_value: {
                type: Object,
                required: true
            },
            idTipoEvento: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                inscricao: { ...this.inscricao_value },
                instituicao: { ...this.instituicao_value }
            };
        },
        methods: {
        },
        mounted() {
        },
        watch: {
            inscricao: {
                handler(newValue) {
                    this.$emit('update:inscricao_value', { ...newValue });
                },
                deep: true
            },
            instituicao: {
                handler(newValue) {
                    this.$emit('update:instituicao_value', { ...newValue });
                },
                deep: true
            }
        },
    };
</script>


<style scoped lang="scss">

    .container-formulario {
        background-color: #f8f8f8;
        padding: 0;
    }

    .painel {
        margin-top: 15px;
        margin-left: 80px;
        margin-right: 50px;
    }

    @media(min-width:992px) {
        .painel {
            margin-left: 40px;
            width: 200px;
            margin-right: 10px;
        }
    }

    @media(min-width:1200px) {
        .painel {
            margin-left: 40px;
            width: 220px;
            margin-right: 10px;
        }
    }

    @media(min-width:1350px) {
        .painel {
            margin-left: 40px;
            width: 250px;
            margin-right: 10px;
        }
    }


    @media(max-width:519px) {
        .painel {
            margin-left: 50px;
            margin-right: 50px;
        }
    }

    .conteudo {
        padding-left: 30px;
        padding-right: 40px;
    }

    @media(min-width:992px) {
        .conteudo {
            padding-left: 10px;
            margin-left: 150px;
        }
    }

    @media(min-width:1000px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 150px;
        }
    }

    @media(min-width:1100px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 150px;
        }
    }

    @media(min-width:1200px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 150px;
        }
    }

    @media(min-width:1300px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 150px;
        }
    }

    @media(min-width:1400px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 140px;
        }
    }

    @media(min-width:1500px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 130px;
        }
    }

    @media(min-width:1600px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 120px;
        }
    }

    @media(min-width:1700px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 100px;
        }
    }

    @media(min-width:1800px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 80px;
        }
    }

    .linha-1 {
        border: 1px solid #d3d3d3;
        background-color: #fff;
        margin-left: 2px;
        margin-right: 2px;
        min-height: calc(100vh);
        border-top: none;
        border-bottom: none;
    }

    @media (min-width: 430px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 32px;
            margin-right: 32px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 550px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 52px;
            margin-right: 32px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 600px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 100px;
            margin-right: 70px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 992px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: calc(10vw - 30px) !important;
            margin-right: calc(10vw - 30px) !important;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1200px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1400px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1500px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1600px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1800px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    .row > * {
        flex-shrink: 1;
    }

    .titulo {
        font-size: 14px;
        color: #bd2344;
        font-weight: 700
    }

    .titulo2 {
        font-size: 21px;
        line-height: 26px;
        color: #7a7a7a;
        margin-top: 5px;
        margin-bottom: 15px;
    }

    .texto-1 {
        font-size: 15px;
        line-height: 20px;
        color: #7a7a7a;
        margin-top: 5px;
    }

    .texto-2 {
        font-size: 15px;
        line-height: 20px;
        color: #7a7a7a;
    }

    .painel-2 {
        margin-top: 10px;
        margin-left: 80px;
        margin-right: 50px;
        padding: 16px;
        margin-bottom: 30px;
    }

    @media(min-width:992px) {
        .painel-2 {
            margin-top: 30px;
            margin-left: 40px;
            width: 200px;
            margin-right: 10px;
        }
    }

    @media(min-width:1200px) {
        .painel-2 {
            margin-top: 30px;
            margin-left: 40px;
            margin-right: 10px;
            width: 220px;
        }
    }

    @media(min-width:1350px) {
        .painel-2 {
            margin-left: 40px;
            width: 250px;
            margin-right: 10px;
        }
    }

    @media(max-width:519px) {
        .painel-2 {
            margin-left: 50px;
            margin-right: 50px;
        }
    }

    .painel-3 {
        display: block;
    }

    .btn-pagination {
        padding: 15px;
        border: none;
    }

    @media(min-width:992px) {
        .btn-pagination {
            padding: 15px;
        }
    }

    .btn-pagination2 {
        padding: 15px;
        border: none;
    }

    @media(min-width:992px) {
        .btn-pgnt2 {
            height: 0;
        }
    }

    .card-painel {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
    }

    @media(min-width:630px) {
        .card-painel {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel {
            visibility: hidden;
            margin: 0;
            height: 0;
        }
    }


    .card-painel2 {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 16px;
    }

    @media(min-width:630px) {
        .card-painel2 {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel2 {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel2 {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel2 {
            visibility: hidden;
            margin: 0;
            padding: 0;
            height: 300px;
            display: block;
        }
    }

    .card-painel3 {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 16px;
    }

    @media(min-width:630px) {
        .card-painel3 {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel3 {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel3 {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel3 {
            visibility: hidden;
            margin: 0;
            padding: 0;
            height: 0;
            display: block;
        }
    }

    .active > .page-link,
    .page-link.active {
        margin-right: 15px !important;
        border-color: #ba2743 !important;
        color: #fff !important;
        background: #ba2743 !important;
        width: 37px !important;
        height: 39px !important;
        text-align: center !important;
        padding-top: 6px !important;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none !important;
        outline-style: none !important;
        z-index: 99 !important;
        margin-left: 10px !important;
        padding-bottom: 10px !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        font-size: 16px !important;
    }


    .formularios {
        font-size: 22px;
        color: #bd2344;
        border-bottom: 1px solid #d3d3d3;
        padding-bottom: 10px;
        display: block;
    }

    .dados-instituicao {
        font-size: 18px;
        color: #bd2344;
        font-weight: 500;
        border-bottom: 1px solid#ececec;
        padding-bottom: 13px;
    }

    .logo {
        height: 34px;
        margin-bottom: 0px;
        margin-left: 10px;
        margin-right: 10px;
        float: right;
    }

    @media(max-width:991px) {
        .logo {
            visibility: hidden;
            height: 0;
            width: 0;
        }
    }

    @media(min-width:992px) {
        .logo {
            height: 34px;
            margin-right: 30px;
            margin-left: 10px;
            float: right;
        }
    }

    @media(min-width:1200px) {
        .logo {
            height: 34px;
            margin-right: 30px;
            margin-left: 10px;
            float: right;
        }
    }

    @media(min-width:1400px) {
        .logo {
            margin-right: 34px;
            float: right;
            height: 34px;
        }
    }

    @media(min-width:1537px) {
        .logo {
            margin-right: 34px;
            float: right;
            height: 34px;
        }
    }

    @media(min-width:1800px) {
        .logo {
            margin-right: 20px;
            float: right;
            height: 34px;
        }
    }

    .evento {
        margin-top: 30px;
        height: 80px;
        width: 150px;
        margin-bottom: 0px;
        margin-right: 20px;
        margin-left: 20px;
    }

    @media(min-width:330px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 250px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 40px;
        }
    }

    @media(min-width:430px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 250px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 60px;
        }
    }

    @media(min-width:530px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 250px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 100px;
        }
    }

    @media(min-width:630px) {
        .evento {
            margin-top: 30px;
            height: 200px;
            width: 300px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 70px;
        }
    }

    @media(min-width:700px) {
        .evento {
            margin-top: 30px;
            height: 250px;
            width: 400px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 80px;
        }
    }

    @media(min-width:800px) {
        .evento {
            margin-top: 30px;
            height: 250px;
            width: 400px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 120px;
        }
    }

    @media(min-width:920px) {
        .evento {
            margin-top: 30px;
            height: 250px;
            width: 400px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 180px;
            margin-bottom: 0;
            align-self: center;
        }
    }

    @media(min-width:992px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 200px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    @media(min-width:1200px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 220px !important;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    @media(min-width:1350px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 250px !important;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    .descritivo {
        color: #777;
    }

    .informacao {
        border-color: #bbbbbb;
        margin-right: 1px;
        font-size: 14px;
    }

    .informacao2 {
        border-color: #bbbbbb;
        font-size: 14px;
    }

    .btn-danger {
        background-color: #bd2344;
        color: #fff;
        margin-top: 20px;
        font-size: 15px;
        font-weight: 700;
        padding: 10px 20px;
        border-radius: 0;
        border: 2px solid #ececec;
    }

    .icon-inscricao {
        padding-right: 5px;
        font-size: 15px;
    }

    .btn-inscricao {
        background-color: #bd2344;
        color: #fff;
        font-size: 15px;
        font-weight: 400;
        padding: 3px 5px;
        border-radius: 0;
        border: 2px solid #ececec;
    }

    @media(min-width:992px) {
        .btn-inscricao {
            background-color: #bd2344;
            color: #fff;
            font-size: 15px;
            font-weight: 400;
            padding: 3px 5px;
            border-radius: 0;
            border: 2px solid #ececec;
        }
    }

    #salvar {
        color: #fff;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 15px;
        font-weight: 500;
        padding: 10px 20px;
        border-radius: 0;
        border: 2px solid #ececec;
        margin-right: 20px;
    }

    .btn-success {
        background-color: #158000;
        color: #fff;
        margin-top: 20px;
        font-size: 15px;
        padding: 10px 20px;
        font-weight: 500;
    }

    .footer {
        border-top: 1px solid #ececec;
        margin-top: 30px;
        border-color: #ddd;
    }

    .footer-2 {
        border-top: 1px solid #ececec;
        margin-top: 30px;
        border-color: #ddd;
        background-color: #f5f5f5;
    }

    .linha-2 {
        margin-left: 0px;
        margin-right: 0px;
        margin-top: 0;
        padding: 10px;
        background-color: #f5f5f5;
        border-color: #ddd;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        display: block;
    }

    .font-1 {
        font-weight: 600;
        font-size: 14px;
        color: #4c4c4c;
    }

    .font-2 {
        font-weight: 600;
        font-size: 14px;
        color: #575757;
        padding-left: 10px;
    }

    .font-3 {
        font-size: 13px;
        margin-bottom: 10px;
        padding-left: 10px;
    }


    @media(min-width:992px) {
        .font-3 {
            font-size: 13px;
            margin-bottom: 3px;
            padding-left: 10px;
        }
    }

    .font-4 {
        font-weight: 700;
        font-size: 16px;
        color: #4c4c4c;
    }

    .font-5 {
        font-weight: 700;
        font-size: 16px;
        color: #4c4c4c;
    }

    .font-6 {
        font-weight: 400;
        color: #707070;
    }

    .font-7 {
        font-weight: 400;
        font-size: 16px;
        color: #4c4c4c;
        margin-top: 20px;
    }

    .input-checkbox {
        margin-top: 23px;
    }

    .btn-secondary {
        background-color: #d8d8d8;
        color: #575757;
        margin-top: 20px;
        font-size: 15px;
        font-weight: 700;
        border: #bbbbbb;
        padding: 10px 20px;
        border-radius: 0;
    }

    .btn-secondary:hover {
        background-color: #d8d8d8;
        color: #575757;
    }

    .btn-link {
        border: 2px solid #f5f5f5;
        background: #f5f5f5;
        width: 37px;
        height: 39px;
        text-align: center;
        padding-top: 5px;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none;
        outline-style: none;
        z-index: 99;
        color: #bbb;
        background: #f5f5f5;
        margin-right: 15px;
        padding-bottom: 10px;
        padding-left: 0;
        padding-right: 0;
        font-size: 16px;
    }

    .btn-link-4 {
        border: 2px solid #f5f5f5;
        background: #f5f5f5;
        width: 43px;
        height: 45px;
        text-align: center;
        padding: 5px 0;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none;
        outline-style: none;
        z-index: 99;
        color: #bbb;
        background: #f5f5f5;
    }

    .cardbody {
        padding: 0;
    }

    .btn-pgnt {
        margin-bottom: 0;
    }

    .btn-pgnt2 {
        margin-bottom: 0;
    }

    @media(min-width:992px) {
        .btn-pgnt2 {
            height: 0;
        }
    }

    .container-2 {
        margin-left: 0;
        margin-top: 0;
    }

    .quantidade-participantes {
        border-color: #7a7a7a;
        font-size: 40px;
        box-shadow: 1px solid !important;
        color: #555 !important;
        font-weight: 600;
    }

    @media(min-width:992px) {
        .quantidade-participantes {
            border-color: #a8a8a8;
            margin-left: 90px;
            font-size: 40px;
        }
    }


    .m-quantidade-participantes {
        padding-top: 60px;
        padding-bottom: 40px;
    }

    #q-participantes {
        color: #4c4c4c;
        font-size: 20px;
        padding-left: 10px;
        font-weight: 600;
    }

    @media(min-width:992px) {
        #q-participantes {
            color: #4c4c4c;
            font-size: 20px;
            padding-left: 15px;
            font-weight: 600;
            margin-left: 95px;
        }
    }

    .paragrafo-1 {
        font-size: 16px;
        color: #96102d;
        padding-right: 40px;
        padding-left: 45px;
        font-weight: 400;
    }

    @media(min-width:992px) {
        .paragrafo-1 {
            font-size: 16px;
            padding-left: 0;
            padding-right: 0;
            margin-bottom: 0;
        }
    }

    .paragrafo-2 {
        font-size: 16px;
        color: #96102d;
        padding-left: 45px;
        padding-right: 40px;
        font-weight: 400;
    }

    @media(min-width:992px) {
        .paragrafo-2 {
            font-size: 16px;
            padding-right: 0;
            padding-left: 0;
        }
    }

    .corpo-col {
        padding-right: 0;
        margin-left: 10px;
    }

    @media(min-width:992px) {
        .corpo-col {
            margin-left: 130px;
            padding-right: 40px;
        }
    }

    .paragrafo-danger {
        font-size: 26px;
        text-align: center;
        color: #333;
        font-weight: 500;
    }
</style>